var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { applyCyAttribute } from "../../utils";
import { colors } from '../../styles';
var FunnelBackIcon = function (_a) {
    var _b = _a.color, color = _b === void 0 ? colors.primary : _b, props = __rest(_a, ["color"]);
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", width: "100%", height: "100%", stroke: color, fill: "none", strokeLinecap: "round", strokeWidth: "4", viewBox: "0 0 27 46" }, applyCyAttribute('funnelBackIcon'), props),
        React.createElement("path", { strokeLinejoin: "round", d: "M3 21.5l22-19" }),
        React.createElement("path", { transform: "matrix(-.992546 -.121869 -.121869 .992546 29.616388 3.872579)", d: "M2.5 40l22-19" })));
};
export default FunnelBackIcon;
//# sourceMappingURL=FunnelBackIcon.js.map